import React from 'react'

const Disclaimer = () => {
    return (
        <div className='disclaimer-main-bg-clr'>
            <div className='container'>
                {/* disclaimer-main-div */}
                <div className='disclaimer-main-div'>
                    <h3>Disclaimer</h3>
                    <p>
                        All drawings and dimensions are approximate. Drawings are not to scale and are subject to change without notice. The developer reserves the right to make revisions. The units are taken from the typical floor of the building and columns may vary in size depending on the floor level. The furnishings and accessories shown are for representation only. The length and width of the unit and balcony varies depending on which floor and which orientation the unit is located within the building to comply with the building authority regulations.</p>
                </div>
            </div>
        </div>
    )
}

export default Disclaimer